import { CardTemplate } from 'types/story';
import { CARD_DEFAULT_TEMPLATE_NAME } from 'common/constants';
import { defaultTemplate } from 'utils/facades/templates/default-template';
import { CardFacadeBase } from 'utils/facades/card-facade-base';

function _defaultTemplate(): CardTemplate {
	const template = defaultTemplate();
	template.editor.card.settings.showResults = false;
	return template;
}

function resultsTemplate(): CardTemplate {
	const template = defaultTemplate();
	template.editor.card.settings.showResults = true;
	return template;
}

const TRIVIA_CUSTOM_TEMPLATES = {
	withResults: 'withResults',
	withSymbols: 'withSymbols',
} as const;

class TriviaFacade extends CardFacadeBase {
	static template = {
		[CARD_DEFAULT_TEMPLATE_NAME]: _defaultTemplate,
		[TRIVIA_CUSTOM_TEMPLATES.withResults]: resultsTemplate,
		// [TRIVIA_CUSTOM_TEMPLATES.withSymbols]: async () => {
		// 	const { default: template } = await import(
		// 		'src/common/utils/facades/templates/trivia-card/t1-answer-symbols.json'
		// 	);
		// 	return template;
		// },
	};
}

export { TriviaFacade };
